<template>
  <div class="list-deliverable-status-bar" :style="`background-color:${publishStatus.color}`">
    <div class="list-deliverable-status-controls">
      <div class="status-bar-button" @click="clickDuplicate">
        <i class="fas fa-copy"></i>
      </div>
      <div class="status-bar-button" v-if="userCanEditDeliverable()" @click="clickDelete">
        <i class="fas fa-trash"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showDeleteModal: false,
      showUnlinkModal: false,
      showRelinkModal: false,
      deleteDisabled: false,
      unlinkDisabled: false,
      relinkDisabled: false,
    }
  },
  props: ["deliverable", "namespace"],
  computed: {
  	...mapState({
  	  state (state) {
  	    return state[this.namespace]
  	  },
  	  deliverableDetail (state, getters) {
  	    return getters[this.namespace + 'deliverableDetail']
  	  },
  	  systemSettings (state, getters) {
  	    return getters['systemSettings']
  	  },
  	  userAbilities (state, getters) {
  	    return getters['userAbilities']
  	  },

  	}),
    publishStatus(){
      if(this.deliverable){
        if(this.deliverable.publish_status){
          return JSON.parse(this.deliverable.publish_status);
        }
      }
      return {};
    }
  },
  methods: {
    clickDelete(){
    	this.$emit('deleteDeliverable', this.deliverable);
    },
    clickDuplicate(){
    	this.$emit('duplicateDeliverable', this.deliverable);
    },
		userCanEditDeliverable() {
            return (this.userAbilities.deleteMediaCall);
        },

  },
  created(){
    
  },
  mounted(){

  },
}
</script>